export default __webpack_public_path__ + "static/LeituraSansTwo-MediumItalic-83e650eeaed79ad69153c11690e2786c.woff";